import * as Sentry from '@sentry/react';

const SENTRY_DEFAULT_DSN = 'https://de2d9f55d55199ff467e95375223b46b@o4512172256264192.ingest.de.sentry.io/4512172302270544';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN || SENTRY_DEFAULT_DSN;

  if (dsn) {
    Sentry.init({
      dsn,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
      tracesSampleRate: 1.0,
      // Trace propagation targets for local & hosted environments
      tracePropagationTargets: ['localhost', /^https:\/\/.*\.run\.app/, /^https:\/\/.*\.uibn\.web\.id/],
      // Capture Replays for 10% of all sessions, plus 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      environment: import.meta.env.MODE || 'production',
    });
  } else {
    console.info('[Sentry] VITE_SENTRY_DSN environment variable is not configured yet.');
  }
}

export { Sentry };
